let html = `<div>
    <div class="settings-param selector" data-name="plugins" data-static="true" data-notice="#{settings_plugins_notice}">
        <div class="settings-param__name">#{settings_plugins_add}</div>
        <div class="settings-param__descr">#{settings_plugins_add_descr}</div>
    </div>
    <div class="settings-param selector" data-name="install" data-static="true">
        <div class="settings-param__name">#{settings_plugins_install}</div>
        <div class="settings-param__descr">#{settings_plugins_install_descr}</div>
    </div>
</div>`

export default html